import {
  FTFIND_EVENT,
  type FTFindEvents,
  type HistoricEventData,
  SQRL_EVENT
} from "../constants/ftfindEvents";
import { eventQBus } from "@otto-ec/event-q-bus";

export class FTFindHistoryEvent {
  static register(event?: HistoricEventData) {
    if (event?.historic) {
      return;
    }
    const bus = eventQBus<FTFindEvents>();

    bus.emit(FTFIND_EVENT.MERGE, {
      topic: SQRL_EVENT.SEARCH_CLOSE,
      data: { historic: true }
    });

    /*                                               */
    bus.emit(FTFIND_EVENT.PUSH, {
      topic: SQRL_EVENT.SEARCH_OPEN,
      data: { historic: true }
    });
  }

  static remove(event?: HistoricEventData) {
    if (event?.historic) {
      return;
    }
    const bus = eventQBus<FTFindEvents>();

    bus.emit(FTFIND_EVENT.SHIFT);
  }
}
